// extracted by mini-css-extract-plugin
export default {"titleContainer":"ListHeaders_titleContainer__YpT-6","buttonContainer":"ListHeaders_buttonContainer__f5+IP","buttonText":"ListHeaders_buttonText__Q1K2y"};